export default __webpack_public_path__ + "static/media/GalanoGrotesque-Bold.99459f96.woff";